import { z } from 'zod';

import {
  OBJECT_STORAGE_IMAGE_CONTENT_TYPES,
  OBJECT_STORAGE_VIDEO_CONTENT_TYPES,
} from '../storage/presign-upload.schemas.js';

export const OBJECT_STORAGE_AUDIO_CONTENT_TYPES = [
  'audio/mp4',
  'audio/mpeg',
  'audio/aac',
  'audio/webm',
  'audio/m4a',
] as const;

/** BR-CONV-13 / BR-CONV-16 / BR-CONV-20: presign scoped to a conversation the caller participates in. */
export const CONVERSATION_ATTACHMENT_CONTENT_TYPES = [
  ...OBJECT_STORAGE_IMAGE_CONTENT_TYPES,
  ...OBJECT_STORAGE_VIDEO_CONTENT_TYPES,
  ...OBJECT_STORAGE_AUDIO_CONTENT_TYPES,
] as const;

export const PresignConversationAttachmentBodySchema = z.object({
  contentType: z.enum(CONVERSATION_ATTACHMENT_CONTENT_TYPES),
  contentLength: z.number().int().positive(),
});
export type PresignConversationAttachmentBody = z.infer<
  typeof PresignConversationAttachmentBodySchema
>;

export const PresignConversationAttachmentResponseSchema = z.object({
  uploadUrl: z.url(),
  storageKey: z.string().min(1),
  expiresAt: z.iso.datetime(),
});
export type PresignConversationAttachmentResponse = z.infer<
  typeof PresignConversationAttachmentResponseSchema
>;
